import { render, staticRenderFns } from "./learningAbilityIndex.vue?vue&type=template&id=4bf35da6&scoped=true"
import script from "./learningAbilityIndex.vue?vue&type=script&lang=js"
export * from "./learningAbilityIndex.vue?vue&type=script&lang=js"
import style1 from "./learningAbilityIndex.vue?vue&type=style&index=1&id=4bf35da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf35da6",
  null
  
)

export default component.exports